import React, { useEffect, useState, createContext } from 'react'
import { isRunningSpecs } from 'components/experiments'
import { Peekaboo } from './usePeekaboo'
import { fetchExperiments } from './experimentUtils'
import { useRouter } from 'next/router'

type PeekabooProviderProps = {
  domain: string
  userId?: string | null
  userAttributes?: {
    [key: string]: string | number
  }
  attributes?: {
    [key: string]: string | number
  }
  onExperimentsLoaded?(experiments: Peekaboo['experiments']): void
}

export const PeekabooContext = createContext<Peekaboo>({ status: 'pending', experiments: [] })

const PeekabooProvider: React.FC<PeekabooProviderProps> = ({
  domain,
  userId,
  userAttributes,
  onExperimentsLoaded,
  children,
}) => {
  const [peekaboo, setPeekaboo] = useState<Peekaboo>({ status: 'pending', experiments: [] })
  const router = useRouter()

  useEffect(() => {
    if (isRunningSpecs()) {
      setPeekaboo({ status: 'ready', experiments: [] })
      return
    }

    fetchExperiments(userId, userAttributes, domain)
      .then((experiments) => {
        setPeekaboo({
          status: 'ready',
          experiments: experiments ?? [],
        })

        if (onExperimentsLoaded) {
          onExperimentsLoaded(experiments)
        }
      })
      .catch(() => {
        setPeekaboo({ status: 'error', experiments: [] })
      })
  }, [userId, domain, router.asPath, userAttributes])

  return <PeekabooContext.Provider value={peekaboo}>{children}</PeekabooContext.Provider>
}

export default PeekabooProvider
